import {Navigate, useLocation, useRouteError} from "react-router-dom";
import React from "react";

const ErrorPage = React.lazy(() => import('pages/ErrorPage'));

const ErrorComponent = () => {

    const error = useRouteError();
    const location = useLocation();

    if (error.status === 401) {
        return <Navigate to={'/login'} state={{isTokenExpired: true, from: location}} replace />
    } else {
        return <ErrorPage/>
    }
}

export default ErrorComponent;